<div class="container-fluid">
    <div class="row">
        <!-- sidemenu block start  -->
        <div class="col-12 col-lg-2 col-xl-2">

            <app-sidebar #sidebar></app-sidebar>

        </div>
        <!-- sidemenu block end  -->

        <!-- content block start  -->
        <div class="col-md-12 col-sm-12  col-lg-10 col-xl-10 mx-auto col-12 content-block mx-auto">
            <div class="content-wrap">
                <!--<button (click)="sidebar.toggleSidebar($event)" class="btn mobile-toggler md-none btn-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                        fill="currentColor">
                        <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2" />
                        <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2" />
                        <path d="M2 4H17M2 9H17M2 14H17" stroke="currentColor" stroke-width="2" />
                    </svg>
                </button>-->
                <div class="nav-header d-flex align-items-center">
                    <a (click)="goBack()" class="floating-btn ms-2 flex-shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M17.5 9.16668H5.34503L9.75586 4.75585L8.57753 3.57751L2.15503 10L8.57753 16.4225L9.75586 15.2442L5.34503 10.8333H17.5V9.16668Z"
                                fill="#56647C" />
                        </svg>
                    </a>
                    <h4 class="nav-title justify-content-center align-items-center text-center flex-grow-1 page-title"
                        id="modal-basic-title">
                        Translation
                        <!-- <sup class="text-beta">Beta</sup> -->
                    </h4>

                </div>
                <div class="content-blockd">
                    <div class="chat-scroll smooth-scroll px-4" #scrollChat>

                        <div class="row">
                            <router-outlet></router-outlet>
                        </div>  
                    </div>
                </div>                
            </div>
            <div  class="offset-lg-1 col-lg-10 col-12">
                <!-- <app-option-style></app-option-style> -->
                <!-- <div class="row">
                    
                    <div class="col-7 col-lg-8 mb-2 px-3 d-grid">
                        
                        <label class="checkbox-container">
                            <input type="checkbox" class="checkbox-input"  [(ngModel)]="checkPromptImageStatus">
                            <span class="checkbox-mark"></span>
                            Are you using Prompt for Image generator?
                        </label>                     
                    </div>

                       
                    <div class="col-5 col-lg-4 text-end mb-2 px-3">                       
                        <app-prompt-list></app-prompt-list>
                    </div>
                </div> -->
                <div class="row px-3">
                    <div class="col-12">
                        <app-chat-textarea></app-chat-textarea>
                    </div>
                </div>

            </div>
            <app-disclaimer-msg></app-disclaimer-msg>
        </div>
        <!-- content block end  -->
    </div>
</div>
<!-- <app-podcast-disclaimer-modal></app-podcast-disclaimer-modal> -->